<template>
  <section id="dashboard-ecommerce">
    <b-overlay :show="onProgress">
      <b-row class="match-height">
        <b-col cols="12">
          <statistics :data="data.statistics"/>
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="6" v-if="!onProgress && data.userMaxRequests.length">
          <users :table-data="data.userMaxRequests" title="کاربران دارای بیشترین درخواست ارسالی"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.userMaxPending.length">
          <users :table-data="data.userMaxPending" title="اقدام کنندگان با بیشترین درخواست منتظر پاسخ"/>
        </b-col>
      </b-row>
    </b-overlay>

  </section>
</template>

<script>
import { BRow, BCol, BOverlay } from 'bootstrap-vue'
import { doubleRaf } from '@/libs/utils'
import Statistics from './statistics.vue'
import users from './usersTable.vue'

export default {
  components: {
    BRow,
    BCol,
    Statistics,
    users,
    BOverlay,
  },
  data() {
    return {
      data: {},
      onProgress: false,
    }
  },
  created() {
    // data
    this.onProgress = true

    this.$http.get('/reports/requests')
        .then(response => {
          this.data = response.data
          doubleRaf(() => {
            this.onProgress = false
          })
        })
  },
}
</script>
